module.exports = __webpack_public_path__ + "static/media/trophy-colored.84c77c61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophy-colored.svg
// module id = 555
// module chunks = 0